module.exports = __webpack_public_path__ + "img/36ce.f9892503.png";